module.exports = __webpack_public_path__ + "img/default.29e298d9.jpg";